import { cn } from "@/lib/utils";
import { bandPaint } from "../bands";
import type { VersionSummary } from "./api";
import { stageMark, stageName, versionLabel } from "./format";

export function VersionChip({ version, foundation, onOpen }: { version: VersionSummary; foundation: boolean; onOpen: () => void }) {
  const markers = version.markers;
  const paint = bandPaint(version.score?.band);
  return (
    <button type="button" data-nonmutating onClick={(event) => { event.stopPropagation(); onOpen(); }}
      className={cn("min-h-11 rounded-md border border-ks-grey-4 px-2 py-1 text-left text-xs text-ks-ink", version.stage === "queued" && "border-dashed")}
      aria-label={`Open ${versionLabel(version)}`}>
      <span className="block font-medium">{versionLabel(version)} {foundation ? "★" : ""}</span>
      <span className="flex items-center gap-1 text-ks-grey-1"><span aria-hidden className="inline-block size-2 rounded-full" style={{ backgroundColor: paint.solid }} />{stageMark(version.stage)}{stageName(version.stage)}{markers?.changes_requested ? " ⚑" : ""}{markers?.foundation_changed ? " ⟳" : ""}{version.pending ? " · pending" : ""}</span>
    </button>
  );
}
